// extracted by mini-css-extract-plugin
export default {"carouselLeftArrow":"CarouselLeftArrow_carouselLeftArrow__YuuT8"};